/**
 * Combines a show's `date` ('YYYY-MM-DD') and `time` ('8:00 PM') fields into
 * a single sortable timestamp. The API returns these as separate fields, so
 * sorting on `date` alone leaves same-day shows in arrival order.
 */
export function getShowDateTime(date: string, time?: string): number {
  const base = new Date(date);
  if (!time) return base.getTime();

  const match = time.match(/^(\d{1,2}):(\d{2})\s*([AaPp][Mm])$/);
  if (!match) return base.getTime();

  const [, hourStr, minuteStr, meridiem] = match;
  let hours = parseInt(hourStr, 10) % 12;
  if (meridiem.toUpperCase() === 'PM') hours += 12;
  const minutes = parseInt(minuteStr, 10);

  base.setHours(hours, minutes, 0, 0);
  return base.getTime();
}
